let vibe_cake_masters_my_module_cards = function( $ ) {

	let $cards,
		anim_speed = 400;

	let _init = function() {
		$cards = $( '.cake-masters-component.my-module-card' );

		if ( $cards.length > 0 ) {
			_setup_cards();
		}
	};

	let _setup_cards = function() {
		$cards.not( '.initialised' ).each( ( index, item ) => {
			let $card = $( item );

			$card.find( '.toggle-lessons-link' ).on( 'click', ( e ) => {
				e.preventDefault();

				_toggle_lessons( $card );
			} );

			$card.addClass( 'initialised' );
		} );
	};

	let _toggle_lessons = function( $card ) {
		let $wrapper = $card.find( '.module-lessons' );

		if ( $wrapper.hasClass( 'animating' ) ) {
			return;
		}

		$wrapper.addClass( 'animating' );

		if ( $wrapper.hasClass( 'open' ) ) {
			_close_lessons( $card );
		} else {
			_open_lessons( $card );
		}

		setTimeout( () => {
			$wrapper.removeClass( 'animating' )
		}, anim_speed );
	};

	let _open_lessons = function( $card ) {
		let $wrapper = $card.find( '.module-lessons' );

		$wrapper.removeClass( 'closed' );
		$wrapper.addClass( 'open' );

		$card.find( '.toggle-lessons-panel' ).slideDown();

		_switch_toggle_link_text( $card.find( '.toggle-lessons-link' ), 'close' );
	};

	let _close_lessons = function( $card ) {
		let $wrapper = $card.find( '.module-lessons' );

		$wrapper.removeClass( 'open' );
		$wrapper.addClass( 'closed' );

		$card.find( '.toggle-lessons-panel' ).slideUp();

		_switch_toggle_link_text( $card.find( '.toggle-lessons-link' ), 'open' );
	};

	let _switch_toggle_link_text = function ( $link, type ) {
		$link.find( '.text' ).text( $link.data( type + '-text' ) );
	};

	$( document ).ready( _init );

} ( jQuery );

module.exports = vibe_cake_masters_my_module_cards;